module.exports = __webpack_public_path__ + "img/title.gif";


//////////////////
// WEBPACK FOOTER
// ./jaguar/js/jquery/jquery_alert/images/title.gif
// module id = 137
// module chunks = 0 1